import * as echarts from 'echarts';
import lightTheme from './light';
import darkTheme from './dark';

export enum DefaultEchartsTheme {
	LIGHT = 'd4c-light',
	DARK = 'd4c-dark',
}

export const registerEchartsThemes = () => {
	echarts.registerTheme(DefaultEchartsTheme.LIGHT, lightTheme);
	echarts.registerTheme(DefaultEchartsTheme.DARK, darkTheme);
};
